import React, { FC } from "react"
import styled from "styled-components"

import { generateConditionalClassName } from "@utils"

import HomeInboxTourVideoSlideshow from "./HomeInboxTourVideoSlideshow/HomeInboxTourVideoSlideshow"
import Observer from "@components/Observer/Observer"

const HomeInboxTourSECTION = styled.section`
  padding-bottom: var(--spacing--2XL);
  overflow: hidden;
  position: relative;

  h2 {
    margin: 0 auto var(--spacing--L);
    max-width: var(--container-width);
    position: relative;
    text-wrap: balance;
    z-index: 1;
  }
`

const HomeInboxTour: FC = () => {
  return (
    <Observer rootMargin="0px 0px -20% 0px">
      {(ref, isObserved) => {
        return (
          <HomeInboxTourSECTION
            className={generateConditionalClassName({
              "HomeInboxTour": true,
            })}
            ref={ref}
          >
            <div className="container">
              <div className="grid">
                <h2
                  className="column column--2-12-M column--3-11-L text-align--center"
                  id="deliver-the-human-touch-at-superhuman-speed"
                >
                  Deliver the human touch at superhuman speed
                </h2>
              </div>
            </div>
            <HomeInboxTourVideoSlideshow isReady={isObserved} />
          </HomeInboxTourSECTION>
        )
      }}
    </Observer>
  )
}

export default HomeInboxTour
